<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    :storeModule="ApplicationCollection"
  />
</template>

<script>
import * as Constants from 'client/util/Constants';
import { DropDownSectionConsts } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import ApplicationsFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/ApplicationsFilters';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const {
  ItemTypeConsts,
  StoreModuleMap,
} = Constants;
const applicationCollection = StoreModuleMap[ItemTypeConsts.application];
const {
  multiSelect,
  selectOne,
} = DropDownSectionConsts;
export default {
  name: 'ApplicationsDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data: () => ({
    ApplicationCollection: applicationCollection,
  }),

  computed: {
    // mapped getters used in DropDownFilterMixin
    ...mapGetters(applicationCollection, [
      'getFilters',
    ]),
    dropDownMenuSections() {
      const menus = [
        {
          menuLabel: 'application status:',
          menuType: selectOne,
          menuItems: [
            {
              filter: ApplicationsFilters.appStatusActive(),
              label: 'active',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.appStatusActive());
              },
            },
            {
              filter: ApplicationsFilters.appStatusError(),
              label: 'error',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.appStatusError());
              },
            },
            {
              filter: ApplicationsFilters.appStatusWarning(),
              label: 'warning',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.appStatusWarning());
              },
            },
            {
              filter: ApplicationsFilters.appStatusDeactivated(),
              label: 'deactivated',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.appStatusDeactivated());
              },
            },
          ],
        },
        {
          menuLabel: 'application type:',
          menuType: selectOne,
          menuItems: [
            {
              filter: ApplicationsFilters.applicationTypePreconfigured(),
              label: 'SAML 2.0 (preconfigured)',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.applicationTypePreconfigured());
              },
            },
            {
              filter: ApplicationsFilters.applicationTypeCustom(),
              label: 'SAML 2.0 (custom)',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.applicationTypeCustom());
              },
            },
            {
              filter: ApplicationsFilters.applicationTypeBookmark(),
              label: 'Bookmark',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.applicationTypeBookmark());
              },
            },
          ],
        },
        {
          menuLabel: 'supported functionality:',
          menuType: multiSelect,
          menuItems: [
            {
              filter: ApplicationsFilters.supFunctionalityJIT(),
              label: 'JIT provisioning',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.supFunctionalityJIT());
              },
            },
            {
              filter: ApplicationsFilters.supFunctionalitySAML(),
              label: 'Identity Management',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.supFunctionalitySAML());
              },
            },
          ],
        },
        {
          menuLabel: 'SAML certificate status:',
          menuType: selectOne,
          menuItems: [
            {
              filter: ApplicationsFilters.samlCertStatusActive(),
              label: 'active',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.samlCertStatusActive());
              },
            },
            {
              filter: ApplicationsFilters.samlCertStatusExpiring(),
              label: 'expiring soon',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.samlCertStatusExpiring());
              },
            },
            {
              filter: ApplicationsFilters.samlCertStatusExpired(),
              label: 'expired',
              action: () => {
                this.handleDropDownAction(ApplicationsFilters.samlCertStatusExpired());
              },
            },
          ],
        },
      ];
      return menus;
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    // mapped actions used in DropDownFilterMixin
    ...mapActions(applicationCollection, [
      'fetchCollection',
      'setFilter',
      'setFilters',
    ]),
  },
};
</script>
